import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Toolbar, AppBar, InputAdornment, Dialog, DialogContent, DialogActions, Button, Icon, IconButton, MenuItem, Typography } from 'material-ui';
import CloseIcon from '@material-ui/icons/Close';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy, SelectFormsy } from '@fuse';
import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import Loader from "other-components/loader/loader";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import { withAlert } from 'react-alert';
//import attachValidationToFormsy from 'formsy-react-validations';
//attachValidationToFormsy('isGreaterThan', 'isGreaterThanEqualTo', 'isSmallerThan');
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css

const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99
    },
    smaller: {
        width: 30,
        height: 20,
    },
});


let cx_cps = [];
let cx_cps_edit = [];

class addCustomer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedContactsMenu: null,
            expanded: 'panel1',
            openComposeDialog: false,
            cp_data: [],
            cp_data_edit: cx_cps_edit,
            cx_data: [],
            titles: [],
            cx_types: [],
            canSubmit: true,
            editCustomerState: {
                cx_id: '',
                cx_type: '',
                cx_ref: '',
                cx_title: '',
                cx_name: '',
                cx_company_name: '',
                cx_tax: '',
                cx_postal_address: '',
                cx_postal_address_country: '',
                cx_postal_address_state: '',
                cx_postal_address_city: '',
                cx_postal_address_zipcode: '',
                cx_billing_address: '',
                cx_billing_address_country: '',
                cx_billing_address_state: '',
                cx_billing_address_city: '',
                cx_billing_address_zipcode: '',
                cx_tax: '',
                cp_title: '',
                cp_name: '',
                cp_nic_ssn_passport: '',
                cp_mobile: '',
                cp_home: '',
                cp_office: '',
                cp_email: '',
                cx_credit_limit: '',
                cx_credit_period: '',
                cx_previlage_discount: '',
                cx_suspended: false,
                cx_active: false,
                cx_contact_persons: [],
            },
            loading: true,
        };

        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
        this.addCustomer = this.addCustomer.bind(this);
        this.pushContactPerson = this.pushContactPerson.bind(this);
        this.removeContactPerson = this.removeContactPerson.bind(this);
        this.clearContactPersons = this.clearContactPersons.bind(this);
        this.copyPostalAddress = this.copyPostalAddress.bind(this);
    }

    addCustomer = (data) => {

        if (this.state.cp_data.length == 0) {
            this.props.alert.error('At least, one Contact Person needed');
        }

        else {

            this.props.closeCustomerDialog();
            this.props.setLoader(true);
            // console.log(data);
            // console.log(this.state.cp_data);
            let post = {
                'customer_profile': data,
                'contact_persons': this.state.cp_data
            }

            // axios.post(`http://localhost:5003/crm/addCustomer`,post)
            axios.post(window.crmServer+`/crm/addCustomer`, post)
                .then(res => {
                    if (res.data.status) {
                        this.props.setLoader(false);
                        this.props.alert.success(res.data.msg);
                    }

                    else {
                        this.props.setLoader(false);
                        this.props.alert.error(res.data.msg);
                    }
                })
        }
    };

    
    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    openNewCustomerDialog() {
        this.setState({ loading: true });
        this.setState({ expanded: 'panel1' });
        this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        // this.setState({ openComposeDialog: false });
        this.props.closeCustomerDialog();
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    pushContactPerson() {

        if(this.refs.cp_name.getValue() != '' && this.refs.cp_address.getValue() != '' && this.refs.cp_office.getValue() != '' && this.refs.cp_name.getValue() != null && this.refs.cp_address.getValue() != null && this.refs.cp_office.getValue() != null){
        cx_cps.push(
            {
                'name': this.refs.cp_name.getValue(),
                'nic_ssn_passport': this.refs.cp_nic_ssn_passport.getValue(),
                'address': this.refs.cp_address.getValue(),
                'address_country': this.refs.cp_address_country.getValue(),
                'address_state': this.refs.cp_address_state.getValue(),
                'address_city': this.refs.cp_address_city.getValue(),
                'address_zipcode': this.refs.cp_address_zipcode.getValue(),
                'phone_mobile': this.refs.cp_mobile.getValue(),
                'phone_home': this.refs.cp_home.getValue(),
                'phone_office': this.refs.cp_office.getValue(),
                'email': this.refs.cp_email.getValue(),
            }
        );
        this.setState({ cp_data: cx_cps });

        this.refs.cp_name.setValue("");
        this.refs.cp_nic_ssn_passport.setValue("");
        this.refs.cp_address.setValue("");
        this.refs.cp_address.setValue("");
        this.refs.cp_address_country.setValue("");
        this.refs.cp_address_state.setValue("");
        this.refs.cp_address_city.setValue("");
        this.refs.cp_address_zipcode.setValue("");
        this.refs.cp_mobile.setValue("");
        this.refs.cp_home.setValue("");
        this.refs.cp_office.setValue("");
        this.refs.cp_email.setValue("");
    }
    }

    removeContactPersonConfirm = (element) => {
        confirmAlert({
            title: 'Confirm to Remove',
            message: 'Are you sure to do this.',
            buttons: [
              {
                label: 'Yes',
                onClick: () => this.removeContactPerson(element)
              },
              {
                label: 'No'
              }
            ]
          })
    };

    removeContactPerson(element) {
        cx_cps = [...this.state.cp_data]; // make a separate copy of the array
        var index = cx_cps.indexOf(element)
        cx_cps.splice(index, 1);
        this.setState({ cp_data: cx_cps });
    }

    clearContactPersons() {
        cx_cps = [];
        this.setState({ cp_data: cx_cps });
    }

    copyPostalAddress() {
        this.refs.cx_billing_address.setValue(this.refs.cx_postal_address.getValue());
        this.refs.cx_billing_address_country.setValue(this.refs.cx_postal_address_country.getValue());
        this.refs.cx_billing_address_state.setValue(this.refs.cx_postal_address_state.getValue());
        this.refs.cx_billing_address_city.setValue(this.refs.cx_postal_address_city.getValue());
        this.refs.cx_billing_address_zipcode.setValue(this.refs.cx_postal_address_zipcode.getValue());
    }



    render() {
        const { classes } = this.props;
        const { expanded } = this.state;
        const { cp_data } = this.state;
        const { titles } = this.state;
        const { cx_types } = this.state;

            return (
                <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md">

                <AppBar className="flex w-full app-bar-size" position="static">
                    <Toolbar className="flex w-full">
                        <Typography className="w-full" variant="subheading" color="inherit">
                            New Customer
                  </Typography>
                        <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Formsy
                    onValidSubmit={this.addCustomer}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref={(form) => this.form = form}
                    className="flex flex-col justify-center"
                >
                    <DialogContent className="p-24">

                        <div className={classes.root}>
                            <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                                <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading}>Customer Details</Typography>
                                    <Typography className={classes.secondaryHeading}></Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    className="flex flex-wrap -mx-3 mb-6"
                                >
                                    <SelectFormsy
                                        className="w-full md:w-1/6 p-8 mt-12"
                                        name="cx_type"
                                        label="Customer Type"
                                        value="Retail"
                                        Required
                                    >
                                        {cx_types.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </SelectFormsy>
                                    <TextFieldFormsy
                                        className="w-full md:w-2/5 p-8 mt-12"
                                        type="text"
                                        name="cx_ref"
                                        ref="cx_ref"
                                        label="Reference Number"
                                        required
                                        autoFocus
                                    />
                                    <div className="w-full md:w-2/5 p-8 mt-12"></div>
                                    <SelectFormsy
                                        className="w-full md:w-1/6 p-8 mt-12"
                                        name="cx_title"
                                        label="Title"
                                        value="Mr"
                                        required
                                    >
                                        {titles.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </SelectFormsy>
                                    <TextFieldFormsy
                                        className="w-full md:w-2/5 p-8 mt-12"
                                        type="text"
                                        name="cx_name"
                                        label="Name"
                                        required
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-2/5 p-8 mt-12"
                                        type="text"
                                        name="cx_company"
                                        label="Company Name"
                                        required
                                    />
                                    <div className="w-full p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                        <TextFieldFormsy
                                            className="w-full p-8 mt-12"
                                            type="text"
                                            name="cx_postal_address"
                                            ref="cx_postal_address"
                                            label="Postal Address"
                                            required
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_postal_address_country"
                                            ref="cx_postal_address_country"
                                            label="Country"

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_postal_address_state"
                                            ref="cx_postal_address_state"
                                            label="State"

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_postal_address_city"
                                            ref="cx_postal_address_city"
                                            label="City"

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_postal_address_zipcode"
                                            ref="cx_postal_address_zipcode"
                                            label="Zipcode"

                                        />
                                    </div>
                                    <div className="w-full p-8 mt-12 justify-center">
                                        <IconButton
                                            className="w-full pt-8"
                                            variant="fab"
                                            color="primary"
                                            onClick={this.copyPostalAddress}
                                        >
                                            <Icon>expand_more</Icon>
                                        </IconButton>
                                    </div>
                                    <div className="w-full p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                        <TextFieldFormsy
                                            className="w-full p-8 mt-12"
                                            type="text"
                                            name="cx_billing_address"
                                            ref="cx_billing_address"
                                            label="Billing Address"
                                            required
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_billing_address_country"
                                            ref="cx_billing_address_country"
                                            label="Country"

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_billing_address_state"
                                            ref="cx_billing_address_state"
                                            label="State"

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_billing_address_city"
                                            ref="cx_billing_address_city"
                                            label="City"

                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cx_billing_address_zipcode"
                                            ref="cx_billing_address_zipcode"
                                            label="Zipcode"

                                        />
                                    </div>
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 p-8 mt-12"
                                        type="text"
                                        name="cx_tax"
                                        label="TAX Number"
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                                <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading}>Contact Persons</Typography>
                                    <Typography className={classes.secondaryHeading}> </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    className="flex flex-wrap -mx-3 mb-6"
                                >
                                    <SelectFormsy
                                        className="w-full md:w-1/5 p-8 mt-12"
                                        name="cp_title"
                                        label="Title"
                                        value="Mr"
                                    >
                                        {titles.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </SelectFormsy>
                                    <TextFieldFormsy
                                        className="w-full md:w-3/5 p-8 mt-12"
                                        type="text"
                                        name="cp_name"
                                        ref="cp_name"
                                        label="Contact Person *"
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/5 p-8 mt-12"
                                        type="text"
                                        name="cp_nic_ssn_passport"
                                        ref="cp_nic_ssn_passport"
                                        label="NIC/SSN/Passport"
                                    />

                                    <div className="w-full p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                        <TextFieldFormsy
                                            className="w-full p-8 mt-12"
                                            type="text"
                                            name="cp_address"
                                            ref="cp_address"
                                            label="Address *"
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cp_address_country"
                                            ref="cp_address_country"
                                            label="Country"
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cp_address_state"
                                            ref="cp_address_state"
                                            label="State"
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cp_address_city"
                                            ref="cp_address_city"
                                            label="City"
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 p-8 mt-12"
                                            type="text"
                                            name="cp_address_zipcode"
                                            ref="cp_address_zipcode"
                                            label="Zipcode"
                                        />
                                    </div>
                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 p-8 mt-12"
                                        type="text"
                                        name="cp_mobile"
                                        ref="cp_mobile"
                                        label="Phone(Mobile)"
                                        validations={{
                                            minLength: 10,
                                            // maxLength: 10,
                                            isNumeric: true
                                        }}
                                        validationErrors={{
                                            minLength: 'This is not a valid Phone Number',
                                            // maxLength: 'This is not a valid Phone Number',
                                            isNumeric: 'This is not a valid Phone Number'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 p-8 mt-12"
                                        type="text"
                                        name="cp_home"
                                        ref="cp_home"
                                        label="Phone(Home)"
                                        validations={{
                                            minLength: 10,
                                            // maxLength: 10,
                                            isNumeric: true
                                        }}
                                        validationErrors={{
                                            minLength: 'This is not a valid Phone Number',
                                            // maxLength: 'This is not a valid Phone Number',
                                            isNumeric: 'This is not a valid Phone Number'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 p-8 mt-12"
                                        type="text"
                                        name="cp_office"
                                        ref="cp_office"
                                        label="Phone(Office) *"
                                        validations={{
                                            minLength: 10,
                                            // maxLength: 10,
                                            isNumeric: true
                                        }}
                                        validationErrors={{
                                            minLength: 'This is not a valid Phone Number',
                                            // maxLength: 'This is not a valid Phone Number',
                                            isNumeric: 'This is not a valid Phone Number'
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/4 p-8 mt-12"
                                        type="text"
                                        name="cp_email"
                                        ref="cp_email"
                                        label="Email"
                                        validations="isEmail"
                                        validationError="This is not a valid email"
                                    />
                                    <div className="md:w-4/5 p-8 mt-12"></div>
                                    <Button
                                        className="md:w-1/5 p-8 mt-12"
                                        variant="raised"
                                        color="secondary"
                                        size="small"
                                        onClick={() => this.pushContactPerson()}
                                    >
                                        Add Person
                            </Button>
                                    <div className="w-full p-8">
                                        <ReactTable
                                            className={classNames(classes.root, "-striped -highlight w-full")}

                                            data={cp_data}
                                            columns={[

                                                {
                                                    Header: "Name",
                                                    accessor: "name",
                                                },
                                                {
                                                    Header: "NIC/SSN/Passport",
                                                    accessor: "nic_ssn_passport",
                                                },
                                                {
                                                    Header: "Address",
                                                    accessor: "address",
                                                },
                                                {
                                                    Header: "Phone(Mobile)",
                                                    accessor: "phone_mobile",
                                                },
                                                {
                                                    Header: "Phone(Home)",
                                                    accessor: "phone_home",
                                                },
                                                {
                                                    Header: "Phone(Office)",
                                                    accessor: "phone_office",
                                                },
                                                {
                                                    Header: "Email",
                                                    accessor: "email",
                                                },
                                                {
                                                    Header: "",
                                                    width: 128,
                                                    Cell: row => (
                                                        <div className="flex items-center">
                                                            <IconButton
                                                                onClick={(ev) => {
                                                                    this.removeContactPersonConfirm(row.original);
                                                                }}
                                                            >
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                        </div>
                                                    )
                                                }
                                            ]}
                                            defaultPageSize={5}
                                            noDataText="No contact persons"
                                        />
                                    </div>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                                <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading}>Customer Privileges</Typography>
                                    <Typography className={classes.secondaryHeading}> </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    className="flex flex-wrap -mx-3 mb-6"
                                >
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 p-8 mt-12"
                                        type="text"
                                        name="cx_credit_limit"
                                        ref="cx_credit_limit"
                                        label="Credit Limit"
                                        value="0"
                                        required
                                        validations={{
                                            isNumeric: true
                                        }}
                                        validationErrors={{
                                            isNumeric: 'This is not a valid Value'
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">LKR</InputAdornment>,
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 p-8 mt-12"
                                        type="text"
                                        name="cx_credit_period"
                                        ref="cx_credit_period"
                                        label="Credit Period"
                                        value="0"
                                        required
                                        validations={{
                                            isNumeric: true
                                        }}
                                        validationErrors={{
                                            isNumeric: 'This is not a valid Value'
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">DAYS</InputAdornment>,
                                        }}
                                    />
                                    <TextFieldFormsy
                                        className="w-full md:w-1/3 p-8 mt-12"
                                        type="text"
                                        name="cx_previlage_discount"
                                        ref="cx_previlage_discount"
                                        label="Previlage Discount"
                                        value="0"
                                        required
                                        validations={{
                                            isNumeric: true,
                                            // isSmallerThan: 100
                                        }}
                                        validationErrors={{
                                            isNumeric: 'This is not a valid Value',
                                            // isSmallerThan: 'This is not a valid Value'
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"></InputAdornment>,
                                            endAdornment: <InputAdornment position="end"><Typography>%</Typography></InputAdornment>,
                                        }}
                                    />
                                    <CheckboxFormsy
                                        className=""
                                        name="cx_suspended"
                                        label="Susspended"
                                    />
                                    <CheckboxFormsy
                                        className=""
                                        name="cx_active"
                                        value="true"
                                        label="Active"
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    </DialogContent>
                    <DialogActions className="justify-right pl-16">
                        <Button
                            type="submit"
                            variant="raised"
                            color="secondary"
                            size="small"
                        //   onClick={() => {
                        //       this.addCustomer(this.state);
                        //     //   this.closeComposeDialog();
                        //   }}
                        //   disabled={!this.canSubmit}
                        >
                            Create
                  </Button>
                        <Button
                            type="reset"
                            variant="raised"
                            color="default"
                            size="small"
                        >
                            Reset
                  </Button>
                        <Button
                            variant="raised"
                            color="primary"
                            size="small"
                            onClick={this.closeNewCustomerDialog}
                        >
                            Close
                  </Button>
                        <Button
                            variant="raised"
                            color="default"
                            size="small"
                        >
                            Help
                  </Button>
                    </DialogActions>
                </Formsy>
            </Dialog>
            );
    }

    componentWillMount() {

        //==================================================================================

        var titles = [];

        axios.get(window.systemServer+'/system/loadTitle')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {

                    titles.push({
                        value: response.data[i].title,
                        label: response.data[i].title
                    });
                }
                this.setState({ titles: titles });
            });

        //==================================================================================

        var cx_types = [];

        axios.get(window.systemServer+'/system/loadCustomerTypes')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {

                    cx_types.push({
                        value: response.data[i].customer_type,
                        label: response.data[i].customer_type
                    });
                }
                this.setState({ cx_types: cx_types });
            });

    }

    componentWillReceiveProps(recievedProps) {
        
        console.log('component will recieve props', recievedProps);

        if(recievedProps.openCustomerDialog!=this.state.openComposeDialog){

            this.setState(
                { 
                    openComposeDialog: recievedProps.openCustomerDialog
                }
            );  
        }
    }
}


export default withStyles(styles, { withTheme: true })(withAlert(addCustomer));



// WEBPACK FOOTER //
// ./src/main/content/crm/widgets/addCustomer.js